import React from 'react';
import { motion } from 'framer-motion';

/**
 * GlassCard Component - DARK EDITION
 * Provides a consistent, high-end "Dark Glassmorphism" container
 * optimized for the Right Choice Health Care premium black theme.
 */

export const GlassCard = ({
  children,
  className = '',
  animate = true,
  delay = 0,
}) => {
  const cardStyles = `
    relative
    overflow-hidden
    bg-white/[0.03] 
    backdrop-blur-2xl 
    border border-white/[0.08] 
    rounded-[2.5rem] 
    shadow-[0_20px_50px_rgba(0,0,0,0.5)] 
    hover:border-white/20
    transition-all duration-500
    ${className}
  `;

  // Standard static card
  if (!animate) {
    return (
      <div className={cardStyles}>
        {/* Subtle interior glow for depth on dark surfaces */}
        <div className='absolute inset-0 bg-gradient-to-br from-white/[0.05] to-transparent pointer-events-none' />
        <div className='relative z-10 h-full'>{children}</div>
      </div>
    );
  }

  // Framer Motion animated card (Performance Optimized)
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-50px' }}
      transition={{
        duration: 0.8,
        delay: delay,
        ease: [0.22, 1, 0.36, 1],
      }}
      className={cardStyles}
    >
      {/* Subtle interior glow to define edges against pure black */}
      <div className='absolute inset-0 bg-gradient-to-br from-white/[0.07] to-transparent pointer-events-none' />

      <div className='relative z-10 h-full'>{children}</div>
    </motion.div>
  );
};

export default GlassCard;
